define('presentation/common/warningModal/viewModels/liveReceptionistScriptIntegrityWarningModalViewModel',[
    'common/collections/collectionSorter',
    'common/presentation/iconNames',
    'common/promises/promiseFactory',
    'constants/systemObjectIconNameConstants',
    'presentation/common/modal',
], function() {
    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    const _promiseFactory = new PromiseFactoryConstructor();

    return function() {
        const self = this;

        const SorterConstructor = require('common/collections/collectionSorter');
        const _sorter = new SorterConstructor();

        const _systemObjectIconNames = require('constants/systemObjectIconNameConstants');

        let _modalService = null;
        let _promise = null;

        const _onIntegrityWarningsChanged = (integrityWarnings) => {
            self.showWarningMessage(integrityWarnings.length > 0);
        };

        const _formatIntegrityWarning = (integrityWarning) => {
            const css = `${self.css()}__integrity-item`;
            switch (integrityWarning.icon){
                case 'phone':
                case 'recording':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.hostedNumber,
                        css: css
                    });
                case 'attendant':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.autoAttendant,
                        css: css
                    });
                case 'forwarding':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.forwardingNumber,
                        css: css
                    });
                case 'liveReceptionistScript':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.liveReceptionistScript,
                        css: css
                    });
                case 'schedule':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.schedule,
                        css: css
                    });
                case 'user-device':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.device,
                        css: css
                    });
                case 'user':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.user,
                        css: css
                    });
                case 'userGroup':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.userGroup,
                        css: css
                    });
                case 'webChatWidget':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.webChatWidget,
                        css: css
                    });
                case 'outboundCallingCampaign':
                    return Object.assign({}, integrityWarning, {
                        iconName: _systemObjectIconNames.outboundCallingCampaign,
                    });
                default:
                    return null;
            }
        };

        self.css = ko.observable('integrity-warning-modal');
        self.isCompositionComplete = ko.observable(false);
        self.isScrollActive = ko.observable(false);
        self.shouldScrollIntoView = ko.observable(true);
        self.shouldContentOverflow = ko.pureComputed(() => self.isCompositionComplete() && self.isScrollActive());

        self.header = ko.observable('');
        self.setHeading = (i18n) => self.header(i18n);

        self.liveReceptionistScript = ko.observable();
        self.showLiveReceptionistScript = ko.pureComputed(() => self.liveReceptionistScript() !== '');
        self.setLiveReceptionistScript = (liveReceptionistScriptPresentationObject) => {
            self.liveReceptionistScript(liveReceptionistScriptPresentationObject);
            return self;
        };

        self.texts = ko.observableArray([]);
        self.addText = ({i18n, addCss = ''}) => {
            const css = ko.pureComputed(() => `${self.css()}__text ${addCss}`);
            self.texts.push({i18n, css});
            return self;
        };

        self.integrityWarningTexts = ko.observableArray([]);
        self.addIntegrityWarningText = ({i18n, addCss = ''}) => {
            const css = ko.pureComputed(() => `${self.css()}__text ${addCss}`);
            self.integrityWarningTexts.push({i18n, css});
            return self;
        };

        self.integrityWarnings = ko.observableArray([]);
        self.integrityWarnings.subscribe(_onIntegrityWarningsChanged);
        self.showWarningMessage = ko.observable(false);
        self.addIntegrityWarnings = (integrityWarnings) => {
            _sorter.multiSort(integrityWarnings, ["entityText", "entityName"]);
            let formattedIntegrityWarnings = integrityWarnings.map((integrityWarning) => _formatIntegrityWarning(integrityWarning));
            self.integrityWarnings(formattedIntegrityWarnings);
            return self;
        };

        self.onCancel = () => {
            self.isCompositionComplete(false);
            _promise.resolve();
            _modalService.closeModal(self);
        };

        self.clearModal = () => {
            self.css('integrity-warning-modal');
            self.texts.removeAll();
            self.integrityWarnings.removeAll();
            self.integrityWarningTexts.removeAll();
            self.setHeading({});
            return self;
        };

        self.showModal = () => {
            const Modal = require('presentation/common/modal');
            _modalService = new Modal();
            _modalService.showModal(self);
            _promise = _promiseFactory.deferIndefinitely();
            return _promise;
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };
    };
});
